import type { CityConfig } from "@/pages/city-template/types";

export const manitowocConfig: CityConfig = {
  city: "Manitowoc",
  state: "Wisconsin",
  stateAbbr: "WI",
  slug: "manitowoc",
  route: "/cities/manitowoc",
  title: "Emergency & Expedited Passport Services Manitowoc WI | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Manitowoc, WI — as fast as 24 hours. No Manitowoc passport agency. Fast Passport Center couriers to the Chicago Passport Agency at 230 S Dearborn St, Suite 380, about 175 miles south via I-43. A+ BBB rated. Serving Lakeshore area families, Manitowoc Company professionals, and Silver Lake College students.",
  h1: "Emergency & Expedited Passport Services in Manitowoc, WI",
  heroSubtitle: "Manitowoc sits along the scenic Lake Michigan shoreline, known for its strong maritime heritage, the Wisconsin Maritime Museum, and the Manitowoc Company's crane manufacturing legacy. Fast Passport Center's registered couriers deliver your documents to the Chicago Passport Agency at 230 S Dearborn St, Suite 380 so you get a new or renewed passport as fast as 24 hours — whether you're a Manitowoc Company professional on international assignment, a Silver Lake College student preparing for study abroad, or a Lakeshore family planning a trip overseas.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Manitowoc%20Wisconsin%20Lake%20Michigan%20shoreline%20with%20the%20lighthouse%20and%20downtown%20riverwalk%20during%20golden%20hour%20sunset%2C%20historic%20Lake%20Michigan%20maritime%20city%20with%20charming%20main%20street%20businesses%2C%20wide%20angle%20professional%20photography%20with%20clean%20composition&width=1800&height=700&seq=manitowoc-wi-hero-001&orientation=landscape",
  heroImageAlt: "Manitowoc Wisconsin Lake Michigan shoreline with lighthouse and downtown riverwalk at sunset",
  geoPosition: "44.0886;-87.6576",
  geoPlacename: "Manitowoc, Wisconsin",
  lastModified: "2026-06-06",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Approximately 175 miles from Manitowoc — about 2 hours 45 minutes via I-43 and I-94",
  },
  nearbyCitiesZips: [
    { name: "Manitowoc", zips: "54220" },
    { name: "Two Rivers", zips: "54241" },
    { name: "Kiel", zips: "53042" },
    { name: "Newton", zips: "53063" },
    { name: "Valders", zips: "54245" },
    { name: "Reedsville", zips: "54230" },
    { name: "Cleveland", zips: "53015" },
    { name: "Mishicot", zips: "54228" },
    { name: "Francis Creek", zips: "54214" },
    { name: "St. Nazianz", zips: "54232" },
    { name: "Whitelaw", zips: "54247" },
    { name: "Brillion", zips: "54110" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Courier delivery to Chicago Passport Agency — 175 miles from Manitowoc via I-43" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-map-pin-2-line", title: "Lakeshore Hub", desc: "Serving Manitowoc, Two Rivers, Kiel, and all Manitowoc County" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your Manitowoc case from start to finish" },
  ],
  internalLinks: [
    { name: "Emergency passport in Chicago IL", route: "/cities/chicago" },
    { name: "Expedited passport in Milwaukee WI", route: "/cities/milwaukee" },
    { name: "Urgent passport in Manitowoc WI", route: "/cities/manitowoc" },
    { name: "Wisconsin passport hub", route: "/states/wisconsin" },
    { name: "Fast passport in Green Bay WI", route: "/cities/green-bay" },
    { name: "Expedited passport in Sheboygan WI", route: "/cities/sheboygan" },
    { name: "Emergency passport in Madison WI", route: "/cities/madison-wi" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Manitowoc remotely via secure courier. Our registered couriers hand-deliver your documents to the Chicago Passport Agency at 230 S Dearborn St, Suite 380 — approximately 175 miles south. Manitowoc's location on the Lake Michigan lakeshore provides direct access to I-43 south toward Milwaukee and Chicago, making overnight courier routing efficient through Wisconsin's eastern corridor. Our dedicated agents ensure Lake Michigan shoreline travelers never need to make the nearly 3-hour drive to Chicago.",
  fpcOfficeDistance: "Serving all of the Manitowoc County lakeshore region",
  serviceAreaIntro: "Fast Passport Center provides emergency and fast passport renewal services throughout Manitowoc, Two Rivers, Kiel, and the greater Manitowoc County area. From Manitowoc Company professionals on international assignments to Silver Lake College students heading abroad, we help Lake Michigan shoreline travelers get their passports fast.",
  nearbyCitiesIntro: "We serve Manitowoc and nearby communities including Two Rivers, Kiel, Valders, Reedsville, Mishicot, and the entire Manitowoc County area.",
  howItWorksIntro: "Most Manitowoc travelers complete everything online and ship documents overnight. At 175 miles from Chicago, Fast Passport Center provides fast courier turnaround for Manitowoc County residents — eliminating the nearly 3-hour drive to the Chicago Passport Agency.",
  mistakesIntro: "Manitowoc travelers, including Manitowoc Company professionals on international assignments and Lakeshore families planning overseas trips, face unique passport challenges. Here are the most common mistakes we see.",
  testimonialsIntro: "Manitowoc and Lake Michigan shoreline travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Manitowoc? Here are the most common ones we hear from Lakeshore area travelers.",
  statePageRoute: "/states/wisconsin",
  statePageName: "Wisconsin",
  dmvWebsite: "https://wisconsindot.gov/Pages/dmv/license-drvs/how-to-apply.aspx",
  dmvLabel: "Wisconsin DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "No drive or appointment needed",
        "Ideal for Manitowoc Company international assignments",
        "Perfect for Lakeshore family vacations abroad",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service USPS",
        "Good for planned travel from GRB or MKE",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "No document review — errors cause rejection",
        "In-person clerk appointment required",
        "Workload shifts with government shutdowns",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "Cannot upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins at 230 S Dearborn St, Suite 380",
        "Life-or-death emergencies only",
        "175 miles to Chicago (2 hours 45 minutes via I-43/I-94)",
        "Still requires pre-scheduled NPIC appointment",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "Manitowoc is 175 miles from the Chicago Passport Agency — our courier service saves Lakeshore travelers the nearly 3-hour drive.",
      bullets: ["Manitowoc County coverage", "24–48 hour turnaround available", "No appointment or drive needed"],
      badge: "Fastest in Manitowoc County",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Manitowoc adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No acceptance clerk visit for most renewals", "Mail-in or courier options", "Serving Manitowoc and Lakeshore communities"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support in Manitowoc County.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Fast replacement for Manitowoc and Lakeshore area residents with DS-64 form guidance.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement via Chicago agency"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support in Manitowoc County.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport name change service after marriage, divorce, or legal changes for Manitowoc County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Manitowoc WI", description: "Urgent passport processing for Manitowoc, WI travelers via Chicago Passport Agency courier — 175 miles from Manitowoc." },
    { name: "Passport Renewal Manitowoc WI", description: "Fast passport renewal for Manitowoc and Manitowoc County, Wisconsin residents." },
    { name: "New Passport Manitowoc WI", description: "First-time passport application assistance for Manitowoc and Lake Michigan shoreline area residents." },
    { name: "Lost Passport Manitowoc WI", description: "Passport replacement for lost or stolen passports for Manitowoc and Lakeshore area residents." },
    { name: "Child Passport Manitowoc WI", description: "Minor passport services for Manitowoc and Manitowoc County families." },
    { name: "Name Change Passport Manitowoc WI", description: "Passport name change service for Manitowoc, WI residents." },
  ],
  testimonials: [
    {
      name: "Michael D.",
      location: "Manitowoc Company Engineer",
      rating: 5,
      text: "I work for the Manitowoc Company and got assigned to a crane installation project in Germany with three weeks notice. My passport had expired six months prior. Fast Passport Center expedited my renewal in 3 business days. Made the project on time.",
      service: "Emergency Renewal",
    },
    {
      name: "Pat & Nancy K.",
      location: "Manitowoc, WI",
      rating: 5,
      text: "Lakeshore couple planning a family reunion cruise to Alaska. We had 6 weeks and both needed renewals. Fast Passport Center handled both applications in 7 business days. The Chicago courier service saved us the long drive.",
      service: "Dual Renewal",
    },
    {
      name: "Daniel S.",
      location: "Two Rivers, WI",
      rating: 5,
      text: "Two Rivers resident who realized my passport was missing 10 days before a fishing trip to Canada. Fast Passport Center helped with the DS-64 form and got my replacement couriered through Chicago. Had my passport in 5 business days.",
      service: "Lost Passport Replacement",
    },
    {
      name: "Jessica L.",
      location: "Silver Lake College",
      rating: 5,
      text: "Silver Lake College nursing student accepted into a summer healthcare program in Costa Rica. Needed a first-time passport with only 3 weeks notice. Fast Passport Center guided me through the DS-11 process and delivered in 6 business days.",
      service: "First-Time Passport",
    },
  ],
  facilities: [
    {
      id: "mtw-1",
      name: "Manitowoc Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "606 E Eva St",
      city: "Manitowoc",
      state: "WI",
      zip: "54220",
      phone: "(920) 683-4516",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Manitowoc — Downtown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary acceptance facility for Manitowoc and Manitowoc County residents. Appointment required. Located near the Manitowoc River.",
      icon: "ri-mail-line",
    },
    {
      id: "mtw-2",
      name: "Manitowoc County Clerk Office",
      type: "County Clerk Passport Acceptance",
      address: "1010 S 8th St",
      city: "Manitowoc",
      state: "WI",
      zip: "54220",
      phone: "(920) 683-4000",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Manitowoc — South side",
      website: "https://www.co.manitowoc.wi.us",
      websiteLabel: "Manitowoc County",
      notes: "County clerk passport acceptance services at the Manitowoc County Courthouse. Convenient location with ample parking.",
      icon: "ri-government-line",
    },
    {
      id: "mtw-3",
      name: "Two Rivers Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1616 22nd St",
      city: "Two Rivers",
      state: "WI",
      zip: "54241",
      phone: "(920) 793-1131",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Two Rivers — 8 miles north",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Two Rivers and northern Manitowoc County residents. Appointment recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "mtw-4",
      name: "Kiel Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "623 Fremont St",
      city: "Kiel",
      state: "WI",
      zip: "53042",
      phone: "(920) 894-2313",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Kiel — 15 miles west",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Kiel and western Manitowoc County residents. Serves the border area with Calumet County.",
      icon: "ri-mail-line",
    },
    {
      id: "mtw-5",
      name: "Mishicot Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "317 E Main St",
      city: "Mishicot",
      state: "WI",
      zip: "54228",
      phone: "(920) 755-2195",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Mishicot — 12 miles north",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Small-town option for northern Manitowoc County and Two Rivers area residents.",
      icon: "ri-mail-line",
    },
    {
      id: "mtw-6",
      name: "Valders Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "109 N Liberty St",
      city: "Valders",
      state: "WI",
      zip: "54245",
      phone: "(920) 775-4811",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Valders — 10 miles west",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Small-town option for Valders and western Manitowoc County residents. Call ahead — limited hours may vary.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Distance to Chicago Agency", agency: "175 miles — 2 hour 45 minute drive on I-43/I-94, but need appointment", fpc: "We drive for you — no appointment needed" },
    { feature: "Appointment Needed", agency: "Yes — call NPIC, very limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-map-pin-line",
      title: "Assuming a Green Bay Passport Agency Exists",
      description: "Many Manitowoc residents assume there is a passport agency in Green Bay — just 40 miles north. There is no passport agency in Green Bay or anywhere in Wisconsin. The Chicago Passport Agency at 230 S Dearborn St, Suite 380 is the closest, 175 miles south. This misconception leads Lakeshore travelers to delay, thinking they can 'just go to Green Bay.'",
    },
    {
      icon: "ri-ship-2-line",
      title: "Maritime Workers Confusing TWIC Cards With Passports",
      description: "Manitowoc's maritime and Great Lakes shipping workers sometimes confuse their Transportation Worker Identification Credential (TWIC) with an international passport. A TWIC card grants access to secure port areas but does not serve as an international travel document. Cruise vacations and international port visits require a valid U.S. passport.",
    },
    {
      icon: "ri-calendar-line",
      title: "Lakeshore Families Waiting Until Summer",
      description: "Manitowoc County families planning international summer vacations often wait until May or June to apply for passports — right when the Manitowoc Post Office and County Clerk are overwhelmed with applications. Start your passport process in February or March for summer travel, especially given Manitowoc's distance from the Chicago agency.",
    },
    {
      icon: "ri-restart-line",
      title: "Not Checking Passport Validity Before Booking International Flights",
      description: "Lake Michigan shoreline travelers often book international flights months in advance without checking passport expiration dates. Most countries require 6 months passport validity beyond your return date. If your passport expires within 6 months of travel, airlines may deny boarding.",
    },
    {
      icon: "ri-image-line",
      title: "Using Wisconsin DMV Photos as Passport Photos",
      description: "Manitowoc residents sometimes try to use Wisconsin driver's license photos or self-taken phone photos for passport applications. Passport photos must be exactly 2x2 inches with a pure white background, neutral expression, and no glasses. Only professional passport photo services meet U.S. Department of State standards.",
    },
    {
      icon: "ri-file-list-line",
      title: "Renewing by Mail When In-Person Is Required",
      description: "Lakeshore area residents with passports that expired more than 5 years ago, were issued under age 16, or have a name change without documentation must use Form DS-11 (in-person application) — not DS-82 (mail-in). Filing the wrong form means your application gets rejected and you start over.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send a prepaid overnight label. Drop at any UPS location in Manitowoc, Two Rivers, or Kiel." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team reviews every document, then couriers to the Chicago Passport Agency — 175 miles south via I-43/I-94." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at the Chicago Passport Agency via our pre-secured courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Manitowoc area address — fully trackable." },
  ],
  faqs: [
    {
      q: "How far is Manitowoc from the Chicago passport agency?",
      a: "Manitowoc is approximately 175 miles from the Chicago Passport Agency at 230 S Dearborn St, Suite 380 in the Chicago Loop — about a 2 hour 45 minute drive south via I-43 and I-94. This makes Manitowoc one of the farthest Wisconsin cities from the agency, with a nearly 6-hour round trip drive. However, the Chicago agency requires pre-scheduled appointments and does not accept walk-ins.",
    },
    {
      q: "Does Manitowoc, WI have its own passport agency?",
      a: "No. Manitowoc does not have a passport agency. The closest passport agency is the Chicago Passport Agency at 230 S Dearborn St, Suite 380, about 175 miles south. Manitowoc has passport acceptance facilities — the Manitowoc Post Office at 606 E Eva St and the Manitowoc County Clerk's office — which can accept your DS-11 application but cannot process or expedite it.",
    },
    {
      q: "Is there a passport agency in Green Bay?",
      a: "No, there is no passport agency in Green Bay or anywhere in Wisconsin. The closest passport agency to all of Wisconsin is the Chicago Passport Agency at 230 S Dearborn St, Suite 380. Green Bay only has passport acceptance facilities — post offices and county clerks that accept applications but cannot expedite processing.",
    },
    {
      q: "Where do Manitowoc travelers typically fly internationally?",
      a: "Manitowoc travelers typically fly from Green Bay Austin Straubel International Airport (GRB, about 40 miles north) or Milwaukee Mitchell International Airport (MKE, about 85 miles south). GRB offers domestic routes with connecting international service, while MKE provides broader domestic and some international routes. Many residents also use Chicago O'Hare for extensive global connections.",
    },
    {
      q: "How fast can I get an emergency passport in Manitowoc?",
      a: "Emergency processing is typically 24–48 hours for Manitowoc residents. Manitowoc's location on the Lake Michigan lakeshore with I-43 access provides reliable overnight courier routing to Chicago. Given Manitowoc's 175-mile distance from the agency — one of the longest in Wisconsin — our courier service is especially valuable for Lakeshore travelers.",
    },
    {
      q: "Where can I get passport photos in Manitowoc?",
      a: "Walgreens at 2701 Calumet Ave and CVS Pharmacy at 3500 Calumet Ave in Manitowoc offer passport photo services. The UPS Store at 3415 Calumet Ave also provides photos. Always verify your photos meet exact 2x2 inch specifications with a white background.",
    },
    {
      q: "Can the Manitowoc County Clerk's office process my passport?",
      a: "Yes. The Manitowoc County Clerk's office at 1010 S 8th St at the Manitowoc County Courthouse accepts passport applications as a passport acceptance facility. They can accept DS-11 applications and verify your documents. Call (920) 683-4000 before visiting to confirm current passport service hours.",
    },
    {
      q: "How do I renew my passport in Manitowoc?",
      a: "Adult renewals meeting all DS-82 eligibility criteria (16 or older, issued within 15 years, same name) can be done entirely by mail. Fast Passport Center's courier service achieves 2–9 business day turnaround — far faster than self-service USPS (8–11 weeks). If you're not eligible for mail-in renewal, visit the Manitowoc Post Office or County Clerk for an in-person DS-11 application.",
    },
    {
      q: "Does the Manitowoc Post Office take walk-in passport appointments?",
      a: "The Manitowoc Post Office at 606 E Eva St accepts passport applications by appointment Monday through Friday from 9:00 AM to 4:00 PM. Walk-ins are generally not accepted — call (920) 683-4516 to schedule. The post office is often busiest during lunch hours and late afternoons.",
    },
    {
      q: "Can Fast Passport Center help Two Rivers and Kiel residents too?",
      a: "Absolutely. We serve all of Manitowoc County and the Lake Michigan shoreline area including Two Rivers, Kiel, Valders, Reedsville, Mishicot, Cleveland, and Newton. Residents of surrounding communities never need to drive to Manitowoc or Chicago for service.",
    },
    {
      q: "I work for the Manitowoc Company and need a passport for an overseas project — what's the timeline?",
      a: "Manitowoc Company professionals assigned to international crane installation or engineering projects should start passport preparation 3–4 months before expected deployment. Emergency processing delivers passports in 24–48 hours, but having a valid passport ready allows flexibility for last-minute international assignments.",
    },
    {
      q: "Is the Manitowoc County Clerk faster than the Post Office for passport applications?",
      a: "Both the Manitowoc Post Office and the County Clerk's office serve as passport acceptance facilities with similar processing capabilities. The County Clerk's office at 1010 S 8th St often has shorter wait times and more flexible hours (8:00 AM–4:30 PM vs. the post office's 9:00 AM–4:00 PM). However, neither facility can expedite processing — that's where Fast Passport Center's courier service comes in.",
    },
  ],
  photoLocations: [
    { name: "Walgreens — Manitowoc", address: "2701 Calumet Ave, Manitowoc, WI 54220", hours: "Mon–Sun: 7AM–10PM" },
    { name: "CVS Pharmacy — Manitowoc", address: "3500 Calumet Ave, Manitowoc, WI 54220", hours: "Mon–Sun: 8AM–9PM" },
    { name: "UPS Store — Manitowoc", address: "3415 Calumet Ave, Manitowoc, WI 54220", hours: "Mon–Fri: 8AM–6PM, Sat: 9AM–2PM" },
    { name: "Walmart Photo — Manitowoc", address: "4115 Calumet Ave, Manitowoc, WI 54220", hours: "Mon–Sun: 7AM–9PM" },
    { name: "Walgreens — Two Rivers", address: "2104 Washington St, Two Rivers, WI 54241", hours: "Mon–Sun: 8AM–10PM" },
    { name: "CVS Pharmacy — Sheboygan", address: "1403 N Taylor Dr, Sheboygan, WI 53081", hours: "Mon–Sun: 8AM–9PM" },
  ],
  dmvLocations: [
    { name: "WI DMV — Manitowoc", address: "3500 Dewey St, Manitowoc, WI 54220", hours: "Mon–Fri: 7:00AM–5:00PM", note: "Full-service DMV center for Manitowoc County. REAL ID, driver's license, and state ID services.", featured: true },
    { name: "WI DMV — Sheboygan", address: "1001 N 6th St, Sheboygan, WI 53081", hours: "Mon–Fri: 7:00AM–5:00PM", note: "Serves southern Manitowoc County and Sheboygan County residents. About 25 miles south of Manitowoc.", featured: false },
    { name: "WI DMV — Green Bay", address: "942 N Military Ave, Green Bay, WI 54303", hours: "Mon–Fri: 7:00AM–5:00PM", note: "Convenient for northern Manitowoc County residents. About 40 miles north of Manitowoc.", featured: false },
  ],
  airports: [
    {
      code: "GRB",
      name: "Green Bay Austin Straubel International Airport",
      distance: "40 miles north of Manitowoc",
      address: "2077 Airport Dr, Green Bay, WI 54313",
      note: "Closest commercial airport to Manitowoc. Domestic routes with connecting international service. About 45 minutes north via I-43.",
      flightUrl: "https://www.flygrb.com/",
      flightLabel: "GRB Airport",
      featured: true,
    },
    {
      code: "MKE",
      name: "Milwaukee Mitchell International Airport",
      distance: "85 miles south of Manitowoc",
      address: "5300 S Howell Ave, Milwaukee, WI 53207",
      note: "Wisconsin's busiest airport with domestic routes and some international service. About 1 hour 25 minutes south via I-43.",
      flightUrl: "https://www.mitchellairport.com/",
      flightLabel: "MKE Airport",
      featured: false,
    },
    {
      code: "ORD",
      name: "Chicago O'Hare International Airport",
      distance: "175 miles south of Manitowoc",
      address: "10000 W O'Hare Ave, Chicago, IL 60666",
      note: "Major international gateway with extensive global routes. About 2 hours 45 minutes south. Co-located near Chicago Passport Agency.",
      flightUrl: "https://www.flychicago.com/ohare/",
      flightLabel: "ORD Airport",
      featured: false,
    },
    {
      code: "MTW",
      name: "Manitowoc County Airport",
      distance: "3 miles west of Manitowoc",
      address: "1815 County Rd Q, Manitowoc, WI 54220",
      note: "General aviation airport serving Manitowoc County. No commercial passenger service. Lakeshore travelers use GRB or MKE for commercial departures.",
      flightUrl: "https://www.co.manitowoc.wi.us/airport/",
      flightLabel: "MTW Airport",
      featured: false,
    },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { icon: "ri-user-smile-line", label: "Birth Certificate", desc: "Request certified birth certificates from the Wisconsin Department of Health Services Vital Records. Online, mail, or in-person options for Manitowoc County residents.", url: "https://www.dhs.wisconsin.gov/vitalrecords/" },
    { icon: "ri-file-list-2-line", label: "Death Certificate", desc: "Obtain certified death certificates through Wisconsin DHS Vital Records. Required for estate, insurance, and legal matters.", url: "https://www.dhs.wisconsin.gov/vitalrecords/" },
    { icon: "ri-hearts-line", label: "Marriage Certificate", desc: "Request marriage license records from the Manitowoc County Register of Deeds. Certified copies for name changes and passport applications.", url: "https://www.co.manitowoc.wi.us/" },
    { icon: "ri-file-copy-line", label: "Divorce Decree", desc: "Obtain certified divorce records through the Manitowoc County Clerk of Courts. Required for name change passport corrections.", url: "https://www.co.manitowoc.wi.us/" },
  ],
};